var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { lazy, Suspense, useCallback, useMemo, useState } from 'react';
import sha1 from 'js-sha1';
import url from 'url';
import { Badge, Dropdown } from 'antd';
import { Button } from '../../../../../components/Buttons';
import Avatar from '../../../../../components/Avatar';
import * as paths from '../../../../Header/constants/paths';
import { useVersion } from '../../../../Header/hooks';
import { ActionIcon, AvatarWrapper, Divider, IconContainer, LoginContainer, ProfileWrapper, StyledBadge, SuperUserIcon, } from './styled';
import { AvatarOutlined } from '../../../../../components/Icon';
import OverlayMenu from './components/OverlayMenu';
import { Apps } from '../../../../Layout/Header/components/Profile/components/Apps';
import { ChatIcon } from './components/Icons';
import { useJwtToken } from '../../../../Layout/Header/hooks';
var SamoletChat = lazy(function () {
    return import('@devdept/samolet-chat').then(function (_a) {
        var SamoletChat = _a.SamoletChat;
        return ({ default: SamoletChat });
    });
});
var NotificationsView = lazy(function () {
    return import('../../../../Layout/Header/components/Profile/components/NotificationsView').then(function (_a) {
        var NotificationsView = _a.NotificationsView;
        return ({ default: NotificationsView });
    });
});
var Profile = function (props) {
    var logout = props.logout, login = props.login, links = props.links, items = props.items, profile = props.profile, chat = props.chat, propsVersion = props.version, propsStand = props.stand, withoutLoginRedirect = props.withoutLoginRedirect, showError = props.showError, profileDropDownProps = props.profileDropDownProps, canHijackUser = props.canHijackUser, hideApplications = props.hideApplications, hideNotifications = props.hideNotifications, notificationsConfig = props.notificationsConfig, jwt = props.jwt, logoutUrl = props.logoutUrl, loginUrl = props.loginUrl, hideRegistrationButton = props.hideRegistrationButton, hideChat = props.hideChat;
    var _a = __read(useState(false), 2), active = _a[0], setActive = _a[1];
    var _b = useVersion(propsVersion, propsStand), version = _b.version, stand = _b.stand;
    var accessToken = useJwtToken({
        withoutLoginRedirect: withoutLoginRedirect,
        showError: showError,
        jwt: jwt,
        skip: hideApplications,
    }).accessToken;
    var chatProps = useMemo(function () { return (__assign(__assign({}, chat), { stand: stand })); }, [chat, stand]);
    var handleOpenChat = useCallback(function () {
        setActive(function (active) { return !active; });
        chat && chat.onOpenChat();
    }, [chat]);
    var handleLogout = useCallback(function () {
        if (!logout)
            return;
        logout();
    }, [logout]);
    var authHref = useMemo(function () { return (!login ? loginUrl !== null && loginUrl !== void 0 ? loginUrl : paths.LOGIN : undefined); }, [login, loginUrl]);
    var hostname = useMemo(function () {
        try {
            return process.env.AVATAR_HOSTNAME || 'avatar.samoletgroup.ru';
        }
        catch (_e) {
            return 'avatar.samoletgroup.ru';
        }
    }, []);
    if (!(profile === null || profile === void 0 ? void 0 : profile.loggedIn))
        return (React.createElement(LoginContainer, null,
            React.createElement(Button, { href: authHref, onClick: login }, "\u0412\u043E\u0439\u0442\u0438"),
            React.createElement(Button, { hidden: hideRegistrationButton, type: 'primary', href: authHref, onClick: login }, "\u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F")));
    var superUserIcon = profile.isSuperuser ? React.createElement(SuperUserIcon, null) : undefined;
    var profileMenu = (React.createElement(OverlayMenu, { links: links, items: items, handleLogout: handleLogout, version: version, canHijackUser: canHijackUser, profile: profile, logoutUrl: logoutUrl }));
    return (React.createElement(ProfileWrapper, null,
        !!chat && !hideChat && (React.createElement(React.Fragment, null,
            React.createElement(ActionIcon, { onClick: handleOpenChat },
                React.createElement(IconContainer, null,
                    React.createElement(StyledBadge, { dot: !!chat.countMessages, offset: [-2, 5] },
                        React.createElement(ChatIcon, { "$isActive": active })))),
            React.createElement(Divider, null),
            React.createElement(Suspense, { fallback: null },
                React.createElement(SamoletChat, __assign({}, chatProps, { jwt: jwt }))))),
        !hideNotifications && (React.createElement(Suspense, { fallback: null },
            React.createElement(NotificationsView, { notificationsConfig: notificationsConfig }))),
        !hideApplications && React.createElement(Apps, { accessToken: accessToken }),
        React.createElement(AvatarWrapper, { title: profile.username },
            React.createElement(Dropdown, __assign({ overlay: profileMenu, getPopupContainer: function (trigger) { return trigger.parentElement || document.body; } }, profileDropDownProps),
                React.createElement(IconContainer, null,
                    React.createElement(Badge, { count: superUserIcon },
                        React.createElement(Avatar, { size: 'small', icon: React.createElement(AvatarOutlined, null), src: url.format({
                                protocol: 'https',
                                hostname: hostname,
                                pathname: "media/" + sha1(profile.username) + ".jpg",
                            }) })))))));
};
export { Profile };
//# sourceMappingURL=Profile.js.map